var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4156 0.584325C17.3186 0.487777 17.1961 0.420932 17.0624 0.391647C16.9287 0.362362 16.7894 0.371856 16.661 0.419012L0.84846 6.16901C0.71209 6.22074 0.594684 6.31273 0.511834 6.43276C0.428985 6.55279 0.384613 6.69519 0.384613 6.84104C0.384613 6.98689 0.428985 7.12929 0.511834 7.24933C0.594684 7.36936 0.71209 7.46135 0.84846 7.51308L7.02252 9.97839L11.5794 5.40714L12.5928 6.42057L8.0144 10.999L10.4869 17.1731C10.5402 17.3068 10.6323 17.4215 10.7515 17.5022C10.8707 17.5829 11.0114 17.626 11.1553 17.6259C11.3006 17.6229 11.4415 17.576 11.5596 17.4913C11.6776 17.4066 11.7672 17.2881 11.8166 17.1515L17.5666 1.33901C17.6156 1.21185 17.6274 1.07338 17.6006 0.939764C17.5739 0.806143 17.5098 0.682873 17.4156 0.584325Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeopy);
export default __webpack_public_path__ + "static/media/seopy.71161ae75fd933d487fe7efa3b2ec494.svg";
export { ForwardRef as ReactComponent };